module.exports = __webpack_public_path__ + "static/media/SOLAR.b40d16aa.png";